<dialog-popup
  title="Feedback"
  [enableScrollWhenOverFlow]="true"
  [showCloseButton]="true"
  [isPrimaryButtonEnabled]="false"
  [isSecondaryButtonEnabled]="false"
  #dialogPopup
>
  @if (renderPopupContent()) {
    <iframe [src]="feedbackURL() | safeUrl" title="Feedback"></iframe>
  }
</dialog-popup>
